import { ComplianceEntity } from "@wingspanhq/wingspan-api-sdk";

/**
 * Whether the entity has a tax identifier (SSN/ITIN/EIN/TIN) stored. v3 never
 * returns a stored identifier's digits — only a `hasValue` flag — so this is the
 * v3 stand-in for both v1 `member.profile.ssnProvided` and
 * `member.profile.ssnLastFourProvided`, which collapse to the same boolean.
 */
export const selectorComplianceEntityHasTaxId = (
  entity: ComplianceEntity | undefined
): boolean => (entity?.taxIdentifiers ?? []).some(taxId => !!taxId.hasValue);
